function addGlobalCSS(themeConfig) {
  let styleNode = document.getElementById('lyearn-global-css');
  if (!styleNode) {
    styleNode = document.createElement('style');
    styleNode.id = 'lyearn-global-css';
    document.head.appendChild(styleNode);
  }

  const isIphone = window.navigator && /iP/i.test(navigator.userAgent);

  const cssString = `
    ${
      isIphone
        ? `
          * {
            cursor: pointer;
          }
        `
        : ''
    }

    :root {
      --color-accent: ${themeConfig.color.accent};
      --color-accent-hover: ${themeConfig.color.accentHover};
      --color-accent-clicked: ${themeConfig.color.accentClicked};
      --color-heading: ${themeConfig.color.heading};
      --color-green-normal: ${themeConfig.color.green};
      --color-green: ${themeConfig.color.green};
      --color-red-normal: ${themeConfig.color.red};
      --color-yellow-normal: ${themeConfig.color.yellow};
      --color-black1: ${themeConfig.color.black1};
      --color-black2: ${themeConfig.color.black2};
      --color-black3: ${themeConfig.color.black3};
      --color-grey1: ${themeConfig.color.grey1};
      --color-grey2: ${themeConfig.color.grey2};
      --color-grey3: ${themeConfig.color.grey3};
      --color-grey4: ${themeConfig.color.grey4};
      --color-indexBg: ${themeConfig.staticColor.learnerIndexBg};
      --color-indexLine: ${themeConfig.staticColor.learnerIndexLine};
    }

    body, input, button {
      font-family: ${themeConfig.font.contentFont} !important;
    }

    body {
      margin: 0;
      padding: 0;
      width: 100%;
      font-size: 16px;
      color: ${themeConfig.color.text} !important;
      background-color: #fff;
      -webkit-font-smoothing: antialiased;
    }

    .theme--color-heading {
      color: ${themeConfig.color.heading} !important;
    }
    .theme--color-primary {
      color: ${themeConfig.color.text} !important;
    }
    .theme--color-secondary {
      color: ${themeConfig.color.textSecondary} !important;
    }
    .theme--color-accent {
      color: ${themeConfig.color.accent} !important;
    }
    .theme--color-green {
      color: ${themeConfig.color.green} !important;
    }
    .theme--color-red {
      color: ${themeConfig.color.red} !important;
    }
    .theme--color-yellow {
      color: ${themeConfig.color.yellow} !important;
    }
    .theme--fill-primary {
      fill: ${themeConfig.color.text} !important;
    }
    .theme--fill-accent {
      fill: ${themeConfig.color.accent} !important;
    }
    .theme--border-primary {
      border-color: ${themeConfig.color.text} !important;
    }
    .theme--border-accent {
      border-color: ${themeConfig.color.accent} !important;
    }
    .theme--border-accent-hover:hover {
      border-color: ${themeConfig.color.accentHover} !important;
    }
    .theme--border-accent-focus:focus {
      border-color: ${themeConfig.color.accentClicked} !important;
    }
    .theme--border-separator {
      border-color: ${themeConfig.color.separator} !important;
    }
    .theme--background-accent {
      background-color: ${themeConfig.color.accent} !important;
    }
    .theme--disabled-opacity {
      opacity: ${themeConfig.disabledOpacity} !important;
    }
    .theme--color-grey1 {
      color: ${themeConfig.color.grey1} !important;
    }
    .theme--fill-grey1 {
      fill: ${themeConfig.color.grey1} !important;
    }
    .theme--background-disabled {
      background-color: ${themeConfig.color.disabledBackground} !important;
    }
  `;

  styleNode.innerHTML = cssString;
}

export default addGlobalCSS;
